module.exports = __webpack_public_path__ + "img/09_BC10_watch_the_pigeon.cc357f64.jpg";